import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { useTranslation } from "react-i18next";
import { GrNext, GrPrevious } from "react-icons/gr";
import { useSelector } from "react-redux";
import axios from "axios";
import images from "../../../../constant/images";

export const VisualPress = () => {
  const { i18n, t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [video, setVideo] = useState("");
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [press_v, setPress_v] = useState(null);
  const [error, seterror] = useState(null);
  const swiperRef = useRef();
  const navigationRefs = useRef({});

  useEffect(() => {
    const fetchVisualPress = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${baseUrl}/press_visual`);
        setPress_v(response.data.press);
      } catch (err) {
        console.error(err);
        seterror(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchVisualPress();
  }, [baseUrl]);

  const openModal = (video) => {
    setVideo(video);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setVideo("");
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="w-9 h-9 border-4 border-black border-l-transparent rounded-full animate-spin"></div>
      </div>
    );
  }


  if (!press_v || press_v.length === 0) {
    return (
      <div className="flex justify-center items-center h-full">
        <h3 className="text-xl font-semibold text-gray-400">No media yet</h3>
      </div>
    );
  }

  return (
    <div className="mb-[7rem]">
      <h1
        id="Audiovisual"
        className="presse text-3xl lg:text-5xl md:text-4xl text-center mb-[3rem] custom-font"
      >
        {t("media.press.AudiovisualPress")}
      </h1>

      <div className="p-12 lg:px-[10rem] lg:mb-[5rem]  md:px-[10rem] md:mb-[5rem]">
        <div className="relative">
          <button className="custom-prev absolute top-1/2 left-[-45px] md:left-[-65px] lg:left-[-65px] transform -translate-y-1/2 z-10 text-2xl rounded-full text-black p-4 bg-white shadow-md hover:bg-[#119f04] hover:text-white transition-all">
            <GrPrevious />
          </button>

          <Swiper
            spaceBetween={25}
            loop={true}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 2 },
              1100: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
            navigation={{
              prevEl: ".custom-prev",
              nextEl: ".custom-next",
            }}
            modules={[Navigation, Pagination , Autoplay]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            className="w-full"
          >
            {press_v.map((item) => {
              if (!navigationRefs.current[item.id]) {
                navigationRefs.current[item.id] = {
                  prevRef: React.createRef(),
                  nextRef: React.createRef(),
                };
              }

              return (
                <SwiperSlide key={item.id} className="h-full w-[400px]">
                  <div className="border-[1px] border-black p-3 h-full ">
                    <div
                      className="relative h-[400px]  lg:h-[400px] md:h-[300px] sm:h-[300px]"
                      style={{
                        backgroundImage: `url(${item.thumbnail})`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <video
                        className="absolute inset-0 w-full h-full object-cover -z-20"
                        loop
                        muted
                      >
                        <source src={item.video} type="video/mp4" />
                      </video>

                      <div className="absolute inset-0 bg-black/60 -z-10"></div>

                      <div className="flex items-center justify-center flex-col h-full gap-3">
                        <img
                          src={images.carbon_play}
                          alt="icon"
                          className="lg:w-[6vw] lg:h-[11vh] cursor-pointer"
                          onClick={() => openModal(item.video)}
                        />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <button className="custom-next absolute top-1/2 right-[-45px] md:right-[-65px] mg:right-[-65px] transform -translate-y-1/2 z-10 text-2xl rounded-full text-black p-4 bg-white shadow-md hover:bg-[#119f04] hover:text-white transition-all">
            <GrNext />
          </button>
        </div>

        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
            <div className="relative lg:max-w-[80vw] lg:h-[80vh] md:max-w-[80vw] md:h-[80vh] max-w-[90vw] bg-white">
              <button
                className="absolute -top-12 right-0 text-white text-3xl"
                onClick={closeModal}
              >
                X
              </button>
              <video className="w-full h-full" controls autoPlay>
                <source src={video} type="video/mp4" />
              </video>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
